import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import en from './locales/en.json'
import es from './locales/es.json'

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            es: { translation: es }
        },
        fallbackLng: 'en',
        debug: true,
        interpolation: {
            escapeValue: false // React already escapes by default
        },
        detection: {
            order: ['localStorage', 'cookie', 'queryString', 'navigator', 'htmlTag'],
            caches: ['localStorage', 'cookie']
        }
    })

export default i18n
